import O1HD from "../../../../engines/gameEngine";
import NormalGameManager from "../../manager/NormalGameManager";
import { getCooperativeShopAry } from "./cooperativeConst";
import cooperativeShopItem from "./cooperativeShopItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class cooperativeShopPage extends cc.Component {

    @property({type:cc.Prefab,displayName:"item预制体"})
    itemPrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    complete?:(isTrue:boolean)=>void

    bindData(complete?:(isTrue:boolean)=>void){
        this.complete = complete;
    }
    
    onLoad(){
        this.loadPage();
    }

    loadPage(){
        let dataAry = getCooperativeShopAry();
        for(let data of dataAry){
            let item:cc.Node = cc.instantiate(this.itemPrefab);
            let is = item.getComponent(cooperativeShopItem);
            is.bindData(data,this.selectOne.bind(this));
            item.setParent(this.itemContent);
        }
    }

    selectOne(node:cc.Node){
        // 选择一个节点
        // let ns = node.getComponent(cooperativeShopItem);
        // let data = ns.data;
        this.closeThis();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }
}
